import { styled } from 'styled-components'
import HomePageVideo from 'pages/HomePage/Components/HomePageVideo/HomePageVideo'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #dff0fd;
`

export const Video = styled(HomePageVideo)`
  width: 100%;
  aspect-ratio: 1178 / 1182;
  overflow: hidden;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 7px 0 44px 0;
  width: 100%;
  text-align: center;
  background: #dff0fd;
  z-index: 1;
  transform: translateY(-2px);
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 330px;
`

export const Title = styled.h2`
  margin: 0;
  font-size: 32px;
  line-height: 1.12;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`

export const Subtitle = styled.p`
  margin: 0;
  font-size: 18px;
  line-height: 1.33;
  font-weight: 400;
  color: #737373;
`
